import { render, staticRenderFns } from "./VSelectServer.vue?vue&type=template&id=89688794&"
import script from "./VSelectServer.vue?vue&type=script&lang=js&"
export * from "./VSelectServer.vue?vue&type=script&lang=js&"
import style0 from "./VSelectServer.vue?vue&type=style&index=0&id=89688794&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports